import React from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from '../components/DatasetActionsContainer';
import DatasetActionMenus from '../components/DatasetActionMenus';
import DatasetActionEditMenus from '../components/DatasetActionEditMenus';

const FullDatasetActions = ({
  accessRequestAllowed,
  accessRequestDisabled,
  accessRequestSupported,
  actions,
  actionsReadStatus,
  allowDownload,
  allowEdit,
  allowManage,
  category,
  code,
  cohortAllowed,
  cohortDisabled,
  cohortSupported,
  dictionaryCode,
  disableDownload,
  disableEdit,
  fetchActions,
  isEditing,
  name,
  notificationHistoryAllowed,
  readStatus,
  showEdit,
  template,
  workflowKey,
}) => (
  <DatasetActionMenus
    accessRequestAllowed={accessRequestAllowed}
    accessRequestDisabled={accessRequestDisabled}
    accessRequestSupported={accessRequestSupported}
    actions={actions}
    actionsReadStatus={actionsReadStatus}
    allowDownload={allowDownload}
    allowManage={allowManage}
    category={category}
    code={code}
    cohortAllowed={cohortAllowed}
    cohortDisabled={cohortDisabled}
    cohortSupported={cohortSupported}
    dictionaryCode={dictionaryCode}
    disableDownload={disableDownload}
    fetchActions={fetchActions}
    name={name}
    notificationHistoryAllowed={notificationHistoryAllowed}
    readStatus={readStatus}
    workflowKey={workflowKey}
  >
    {allowEdit && (
    <DatasetActionEditMenus
      category={category}
      code={code}
      disableEdit={disableEdit}
      isEditing={isEditing}
      showEdit={showEdit}
      template={template}
    />
    )}
  </DatasetActionMenus>
);

export default connect(mapStateToProps, mapDispatchToProps)(FullDatasetActions);
